import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AlertComponent } from '../directives/alert.component';
import { TAB_COMPONENTS } from '../directives/mytabset';
import { OnlyNumber } from '../directives/only-number.directive';
import { UnderlineDirective } from './underline.directive';
import { IfDirective } from './if.directive';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TooltipModule } from 'ngx-bootstrap';
import { EllipsisPipe } from '../pipes/elipsis.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxChartsModule,
    TooltipModule.forRoot()
  ],
  declarations: [
    AlertComponent,
    OnlyNumber,
    UnderlineDirective,
    IfDirective,
    TAB_COMPONENTS,
    EllipsisPipe
  ],
  providers: [

  ],
  exports: [
    AlertComponent,
    OnlyNumber,
    UnderlineDirective,
    IfDirective,
    TAB_COMPONENTS,
    EllipsisPipe
  ]
})
export class AppSharedModule { }


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/shared/app-shared.module.ts